export {
	Store,
	TableChangesResponse,
	TablePermission,
	Tuple,
} from "../dist/dev/moment/differential/v1alpha1/store_rbt_web";
export {
	ChangesResponse,
	PageAuthority,
	PageAuthorityApplyAborted,
} from "../dist/dev/moment/page/v1alpha1/authority_rbt_web";
